import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AuditLog {
    id: string;
    timestamp: string;
    user: string;
    action: string;
    entityType: string;
    entityId: string;
    details: string;
}

@Injectable({
    providedIn: 'root'
})
export class AuditService {
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getAuditLogs(): Observable<AuditLog[]> {
        return this.http.get<AuditLog[]>(`${this.apiUrl}/audit/logs`);
    }
}
